<div class="container-fluid py-3">
    <div class="d-flex align-items-center justify-content-between mb-2 mr-2 ml-2">
      <h4 class="main-heading">Promo Codes</h4>
        <button class="custom-btn mt-3 ml-0" *ngIf="!props"  type="button" (click)="addUserPromoCode()">
        Add Promo Code
      </button>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-md-12">
                <div class="acute">
                  <div class="w-100 h-100 d-flex align-items-center justify-content-center loader"
                    *ngIf="progress_spinner">
                    <span class="purpleLoader"></span>
                  </div>
                  <div *ngIf="!progress_spinner">
                    <table mat-table [dataSource]="dataSource">
  
                      <ng-container matColumnDef="PromoCode">
                        <th mat-header-cell *matHeaderCellDef> Promo Code </th>
                        <td mat-cell *matCellDef="let element"> {{element.code}} </td>
                      </ng-container>
  
                      <ng-container matColumnDef="ExpireDate">
                        <th mat-header-cell *matHeaderCellDef> Expire Date </th>
                        <td mat-cell *matCellDef="let element"> {{element.expires_at ? (helperService.getDate(element.expires_at) + ' ' + helperService.getTime(element.expires_at)) : '-' }} </td>
                      </ng-container>
  
                      <ng-container matColumnDef="Discount">
                        <th mat-header-cell *matHeaderCellDef> Discount </th>
                        <td mat-cell *matCellDef="let element"> {{element.value}} </td>
                      </ng-container>
  
                      <ng-container matColumnDef="MaxValue">
                        <th mat-header-cell *matHeaderCellDef> Max Value </th>
                        <td mat-cell *matCellDef="let element"> {{element.max_value}} </td>
                      </ng-container>
  
                      <ng-container matColumnDef="Limitation">
                        <th mat-header-cell *matHeaderCellDef> Limitation </th>
                        <td mat-cell *matCellDef="let element"> {{element.redemptions}} </td>
                      </ng-container>
  
                      <ng-container matColumnDef="Mode">
                        <th mat-header-cell *matHeaderCellDef> Mode </th>
                        <td mat-cell *matCellDef="let element"> {{element.value_type}}
                          {{element.contact_preference?.time}} </td>
                      </ng-container>

                      <ng-container matColumnDef="RemainingBalance">
                        <th mat-header-cell *matHeaderCellDef> Remaining Balance </th>
                        <td mat-cell *matCellDef="let element"> {{element.remaining_balance}} </td>
                      </ng-container>
  
                      <ng-container matColumnDef="CreatedBy">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let element">
                          <button class="custom-btn mr-2" type="button" (click)="removeAndActivePromoCodeFromOrder(element)"
                          >
                          {{ element?.active ? "Remove" : "Active" }}
                        </button>
                        </td>
                        <!-- <td mat-cell *matCellDef="let element"> {{element.created_at ? helperService.getDate(element.created_at) : '-' + ' ' + element.created_at ? helperService.getTime(element.created_at) : '-' }} </td> -->
                      </ng-container>

  
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
                      </tr>
                    </table>
  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
